import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';

@Component({
    selector: 'app-redirect',
    standalone: true,
    template: `
        <div class="auth-splash">
            <svg class="auth-spinner" viewBox="25 25 50 50">
                <circle class="auth-path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10" />
            </svg>
            <p class="auth-message">Signing you in&hellip;</p>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    styles: [`
        :host {
            position: fixed;
            inset: 0;
            display: block;
            background: #fff;
            font-family: Roboto, "Helvetica Neue", Arial, sans-serif;
        }

        .auth-splash {
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 16px;
        }

        .auth-spinner {
            height: 56px;
            width: 56px;
            animation: auth-rotate 2s linear infinite;
            transform-origin: center center;
        }

        .auth-path {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
            animation: auth-dash 1.5s ease-in-out infinite;
            stroke-linecap: round;
            stroke: #21376c;
        }

        .auth-message {
            margin: 0;
            color: #5F5E63;
            font-size: 14px;
            /* Delay the text so quick redirects never flash a message */
            opacity: 0;
            animation: auth-fade-in 0.4s ease-in 1s forwards;
        }

        @keyframes auth-rotate {
            100% { transform: rotate(360deg); }
        }

        @keyframes auth-dash {
            0% {
                stroke-dasharray: 1, 200;
                stroke-dashoffset: 0;
            }
            50% {
                stroke-dasharray: 89, 200;
                stroke-dashoffset: -35px;
            }
            100% {
                stroke-dasharray: 89, 200;
                stroke-dashoffset: -124px;
            }
        }

        @keyframes auth-fade-in {
            to { opacity: 1; }
        }
    `],
})
export class RedirectComponent implements OnInit {
    ngOnInit(): void {
        broadcastResponseToMainFrame().catch((error: Error) => {
            console.error('Error broadcasting response to main frame:', error);
        });
    }
}
